import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "Yvooa-Core",
  storage: sessionStorage,
});

export const vendorId = atom({
  key: "vendorId",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const bankId = atom({
  key: "bankId",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const leaseId = atom({
  key: "leaseId",
  default: "",
  effects_UNSTABLE: [persistAtom],
});
